import { render } from "./CommonAuth.vue?vue&type=template&id=2a73bef6"
import script from "./CommonAuth.vue?vue&type=script&lang=js"
export * from "./CommonAuth.vue?vue&type=script&lang=js"
script.render = render

export default script